import { TDispatchFunc, IDispatchToProps } from '../types';

export const moreKeyCommonMapStateToProps = (state: any, props: any) => {
  const { opinionMarketingFilter } = state;
  const { instanceId } = props;
  const realValue = opinionMarketingFilter[instanceId];

  return {
    filterValue: realValue,
  };
};

export const moreKeyCommonMapDispatchToProps = (
  dispatch: TDispatchFunc,
  ownProps: IDispatchToProps,
) => {
  const { instanceId } = ownProps;

  return {
    change: (value: any) => { 
      dispatch({
        type: 'opinionMarketingFilter/UPDATE_FILTER',
        payload: value,
        instanceId,
      });
    },
  };
};
